var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OpenAPIDisclosure } from './OpenAPIDisclosure';
import { OpenAPISchemaProperties } from './OpenAPISchemaServer';
import { parameterToProperty, resolveDescription } from './utils';
/**
 * Display an interactive response body.
 */
export function OpenAPIResponse(props) {
    var _a, _b;
    var response = props.response, context = props.context, mediaType = props.mediaType;
    var headers = Object.entries((_a = response.headers) !== null && _a !== void 0 ? _a : {}).map(function (_a) {
        var name = _a[0], header = _a[1];
        return [name, header !== null && header !== void 0 ? header : {}];
    });
    var content = Object.entries((_b = mediaType.schema) !== null && _b !== void 0 ? _b : {});
    var description = resolveDescription(response);
    if (content.length === 0 && !description && headers.length === 0) {
        return null;
    }
    return (<div className="openapi-response-body">
            {headers.length > 0 ? (<OpenAPIDisclosure icon={context.icons.plus} label="Headers">
                    <OpenAPISchemaProperties properties={headers.map(function (_a) {
                var name = _a[0], header = _a[1];
                return parameterToProperty(__assign({ name: name }, header));
            })} context={context}/>
                </OpenAPIDisclosure>) : null}
            {mediaType.schema && (<div className="openapi-responsebody">
                    <OpenAPISchemaProperties id={"response-".concat(context.blockKey)} properties={[{ schema: mediaType.schema }]} context={context}/>
                </div>)}
        </div>);
}
